export default __webpack_public_path__ + "static/media/logoDQT.6e582522.jpg";